import { HirerAuthProvider } from '@seek/hirer-auth-react';
import { HirerApolloProvider } from '@seek/hirer-graphql-react';
import { VocabProvider } from '@vocab/react';
import { Box, BraidProvider } from 'braid-design-system';
import seekJobs from 'braid-design-system/themes/seekJobs';
import { useRoutes } from 'react-router';

import { DatadogProvider } from 'src/components/Datadog/Datadog';
import ErrorBoundary from 'src/components/ErrorBoundary/ErrorBoundary';
import { routes } from 'src/routes';
import type { ConfigContextTypes } from 'src/types';
import { configContext } from 'src/utils/config-context';
import { IntegrationPartnerProvider } from 'src/utils/hooks/useIntegrationPartners';

export const App = ({ config }: { config: ConfigContextTypes }) => {
  const { site, environment } = config;

  const graphUri =
    environment === 'development'
      ? 'https://talent.staging.seek.com.au/graphql'
      : '/graphql';

  return (
    <configContext.Provider value={config}>
      <VocabProvider language={config.language}>
        <HirerAuthProvider authenticationLevel="None">
          <HirerApolloProvider
            appName="indie-partner-hub"
            site={site}
            uri={graphUri}
          >
            <DatadogProvider env={environment} version={config.version}>
              <IntegrationPartnerProvider>
                <BraidProvider theme={seekJobs}>
                  <ErrorBoundary>
                    <Box>{useRoutes(routes)}</Box>
                  </ErrorBoundary>
                </BraidProvider>
              </IntegrationPartnerProvider>
            </DatadogProvider>
          </HirerApolloProvider>
        </HirerAuthProvider>
      </VocabProvider>
    </configContext.Provider>
  );
};
